import { Brands } from "./Enums";
export var getTags = function (params) {
    var _a;
    var livestream = params.livestream, longForm = params.longForm, network = params.network, podId = params.podId, seriesName = params.seriesName, video_content_length_format = params.video_content_length_format, releaseType = params.releaseType, videoId = params.videoId, sport = params.sport;
    var type = "Video"; // cannot determine if content is audio only or video right now
    return _a = {},
        _a[Brands.FOX] = {
            LONGFORM: {
                allow_custom_scripts: true,
                u8: network,
                u9: sport,
                u10: seriesName,
                u11: releaseType,
                u12: livestream,
                u13: video_content_length_format,
                u14: podId,
                send_to: GoogleAnalyticsId + "/allvi0/alllo001+standard",
            },
            LONGFORM_UNIQUE: {
                allow_custom_scripts: true,
                u8: network,
                u9: sport,
                u10: seriesName,
                u11: releaseType,
                u12: livestream,
                u13: video_content_length_format,
                u14: podId,
                send_to: GoogleAnalyticsId + "/allvi0/alllo000+unique",
            },
            SHORTFORM: {
                allow_custom_scripts: true,
                u8: network,
                u9: sport,
                u10: seriesName,
                u11: releaseType,
                u12: livestream,
                u13: video_content_length_format,
                u14: podId,
                send_to: GoogleAnalyticsId + "/allvi0/allsh00+standard",
            },
            VIDEO: {
                allow_custom_scripts: true,
                u8: network,
                u9: sport,
                u10: seriesName,
                u11: releaseType,
                u12: livestream,
                u13: video_content_length_format,
                u14: podId,
                send_to: GoogleAnalyticsId + "/allvi0/allvi000+standard",
            },
            VIDEO_UNIQUE: {
                allow_custom_scripts: true,
                u8: network,
                u9: sport,
                u10: seriesName,
                u11: releaseType,
                u12: livestream,
                u13: video_content_length_format,
                u14: podId,
                send_to: GoogleAnalyticsId + "/allvi0/allvi001+unique",
            },
        },
        _a[Brands.NATION] = {
            LONGFORM: {
                allow_custom_scripts: true,
                u2: document.title,
                u3: document.URL,
                u7: longForm,
                u8: videoId,
                u9: type,
                send_to: GoogleAnalyticsId + "/cntst/conte002+standard",
            },
            SHORTFORM: {
                allow_custom_scripts: true,
                u2: document.title,
                u3: document.URL,
                u7: longForm,
                u8: videoId,
                u9: type,
                send_to: GoogleAnalyticsId + "/cntst/conte003+standard",
            },
            VIDEO: {
                allow_custom_scripts: true,
                u2: document.title,
                u3: document.URL,
                u7: longForm,
                u8: videoId,
                u9: type,
                send_to: GoogleAnalyticsId + "/cntst/conte001+standard",
            },
        },
        _a[Brands.FOXNEWS] = {
            LONGFORM: {
                allow_custom_scripts: true,
                u2: document.title,
                u3: document.URL,
                u7: longForm,
                u8: videoId,
                u9: type,
                send_to: GoogleAnalyticsId + "/cntst/conte002+standard",
            },
            SHORTFORM: {
                allow_custom_scripts: true,
                u2: document.title,
                u3: document.URL,
                u7: longForm,
                u8: videoId,
                u9: type,
                send_to: GoogleAnalyticsId + "/cntst/conte003+standard",
            },
            VIDEO: {
                allow_custom_scripts: true,
                u2: document.title,
                u3: document.URL,
                u7: longForm,
                u8: videoId,
                u9: type,
                send_to: GoogleAnalyticsId + "/cntst/conte001+standard",
            },
        },
        _a;
};
export var fireTag = function (data) {
    var gtag = window.gtag;
    if (gtag) {
        console.debug("Fire Floodlight Tag", data);
        gtag("event", "conversion", data);
    }
};
var fireFloodlightEvent = function (params, isLongForm) {
    var _a, _b, _c, _d, _e;
    if (!FloodlightEnabled)
        return;
    var mediaInfo = params.mediaInfo, podId = params.podId;
    var _f = mediaInfo.id, id = _f === void 0 ? null : _f, _g = mediaInfo.network, network = _g === void 0 ? "" : _g, _h = mediaInfo.seriesName, seriesName = _h === void 0 ? "" : _h, _j = mediaInfo.sportTag, sportTag = _j === void 0 ? "" : _j, _k = mediaInfo.releaseType, releaseType = _k === void 0 ? "" : _k, trackingData = mediaInfo.trackingData;
    var programType = (_b = (_a = trackingData === null || trackingData === void 0 ? void 0 : trackingData.properties) === null || _a === void 0 ? void 0 : _a.programType) !== null && _b !== void 0 ? _b : "";
    var data = {
        livestream: releaseType === "VOD" ? "false" : "true",
        podId: podId,
        network: network,
        releaseType: releaseType,
        videoId: id,
        video_content_length_format: isLongForm ? "long-form" : "short-form",
        longForm: isLongForm ? "yes" : "no",
        seriesName: seriesName,
        sport: sportTag || programType,
    };
    var brand = (_e = (_d = (_c = window.ExternalConfig) === null || _c === void 0 ? void 0 : _c.brand) === null || _d === void 0 ? void 0 : _d.businessUnit) !== null && _e !== void 0 ? _e : "fox";
    var brandTags = getTags(data)[brand];
    switch (brand) {
        case Brands.FOX: {
            fireTag(brandTags.VIDEO);
            fireTag(brandTags.VIDEO_UNIQUE);
            if (isLongForm) {
                fireTag(brandTags.LONGFORM);
                fireTag(brandTags.LONGFORM_UNIQUE);
            }
            else {
                fireTag(brandTags.SHORTFORM);
            }
            break;
        }
        case Brands.NATION:
        case Brands.FOXNEWS: {
            fireTag(brandTags.VIDEO);
            if (isLongForm)
                fireTag(brandTags.LONGFORM);
            else
                fireTag(brandTags.SHORTFORM);
            break;
        }
    }
};
export default fireFloodlightEvent;
